import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'

export const StatsYearSelectorEmpty = () => {
  const { colors } = useTheme()

  return (
    <div>
      <Text
        className={css`
          padding: 0 12px 12px;
        `}
        type="label"
        sizing="L"
        color={colors.uiWhite}
        weight="500"
      >
        You have no stats in other years.
      </Text>
    </div>
  )
}
